module.exports = __webpack_public_path__ + "static/img/logo-relatorio-retrato.6da3399.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens/logo-relatorio-retrato.jpg
// module id = 119
// module chunks = 1